import React from 'react';
export const Nav01DataSource = (t)=>({
  wrapper: { className: 'header0 home-page-wrapper' },
  page: { className: 'home-page' },
  logo: {
    className: 'header0-logo',
    children: 'https://www.bmr-oe.com/static/images/logo15.png',
  },
  Menu: {
    className: 'header0-menu',
    children: [
      {
        name: 'item~mf2ezm8vyd',
        className: 'header0-item',
        children: {
          href: '/#',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <p>{t('hATR3zLwrbJVnBo1sBd63')}</p>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item0',
        className: 'header0-item',
        children: {
          href: '#',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <p>{t('ZkxgVNO8eooTs73PRqJdk')}</p>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
        subItem: [
          {
            name: 'sub0',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m9mfhrvs9sh-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/强激光78.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8wyzpxxeu-editor_css',
                  children: (
                    <span>
                      <span>
                        <p>{t('C1sZR_CvTwmG1WX4W5I6n')}</p>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second1',
            },
          },
          {
            name: 'sub1',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/通用双轴50.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <p>{t('nqpWiNKVlKD6N6Yq5z2_C')}</p>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second2',
            },
          },
          {
            name: 'sub~m8x12rhcd3r',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/单轴50.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <p>{t('Vtd_xO08PcvrAw76Iocte')}</p>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second3',
            },
          },
          {
            name: 'sub~m8x12unqvh',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/摆扫镜30.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <span>
                                  <span>
                                    <p>{t('mpwDleB1EL9L1k0xViCqr')}</p>
                                  </span>
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second4',
            },
          },
          {
            name: 'sub~m8x12vr6qz',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/振镜6240.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <p>{t('M1mZHtgTCwqSX-nzIt25K')}</p>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second5',
            },
          },
          {
            name: 'sub~m8x12wndado',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/电调镜78.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <p>{t('X9XQQq9-2ll9r1yDOkCm2')}</p>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second6',
            },
          },
          {
            name: 'sub~m8x12xgznka',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/电动镜127.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <p>{t('ojH4mFJmUbq1Y0qSjCd56')}</p>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second7',
            },
          },
          {
            name: 'sub~m8x12yp8s7o',
            className: 'item-sub m976jn6jedn-editor_css',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/激光通信20.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <span>
                                  <span>
                                    <span>
                                      <span>
                                        <span>
                                          <span>
                                            <p>{t('rq8cYICfTlqxp0aQzHnmc')}</p>
                                          </span>
                                        </span>
                                      </span>
                                    </span>
                                  </span>
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second8',
            },
          },
          {
            name: 'sub~m9mfjmjr4va',
            className: 'item-sub m976jn6jedn-editor_css',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/永磁同步75.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <span>
                                  <span>
                                    <span>
                                      <span>
                                        <span>
                                          <p>{t('ozx0lfvJyO85MAHU7Tinu')}</p>
                                        </span>
                                      </span>
                                    </span>
                                  </span>
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second9',
            },
          },
        ],
      },
      {
        name: 'item1',
        className: 'header0-item',
        children: {
          href: '/#/fourth',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <p>{t('RDVrFX4NZ0SMRRvl0jPo7')}</p>
                      </span>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item2',
        className: 'header0-item',
        children: {
          href: '/#/tenth',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <p>{t('RTiId7VBLKMJT5yxApDFs')}</p>
                      </span>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item3',
        className: 'header0-item',
        children: {
          href: '/#/fifth',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <p>{t('e3q-F7VHj4oOnJScmhxBx')}</p>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item~m98pdg3g8rs',
        className: 'header0-item',
        children: {
          href: '/#/sixth',
          children: [
            {
              children: (
                <span>
                  <span>
                    <p>{t('VY9ISrkhdZgbp22Lh0F0I')}</p>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
    ],
  },
  mobileMenu: { className: 'header0-mobile-menu' },
});
export const Banner10DataSource = (t)=>({
  wrapper: { className: 'banner1 m8wmyqt62ma-editor_css' },
  BannerAnim: {
    children: [
      {
        name: 'elem0',
        BannerElement: { className: 'banner-user-elem' },
        textWrapper: { className: 'banner1-text-wrapper' },
        bg: { className: 'bg bg0 m8wmxqt4hsf-editor_css' },
        title: { className: 'banner1-title', children: '' },
        content: {
          className: 'banner1-content m8wt5yzvohu-editor_css',
          children: (
            <span>
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <blockquote>
                                {t('0sGX4uLbSY7mE7rlTlRTW')}
                              </blockquote>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          ),
        },
        button: {
          className: 'banner1-button m8wtjvr1hjk-editor_css',
          children: (
            <span>
              <span>
                <p>
                  <br />
                </p>
              </span>
            </span>
          ),
        },
      },
      {
        name: 'elem2',
        BannerElement: { className: 'banner-user-elem' },
        textWrapper: { className: 'banner1-text-wrapper' },
        bg: { className: 'bg bg1 m96u0zciy-editor_css' },
        title: { className: 'banner1-title', children: '' },
        content: {
          className: 'banner1-content m96ve128cj-editor_css',
          children: (
            <span>
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <p>{t('-i4GsjqWyJexAzN4T5DGX')}</p>
                          <p>{t('M2cJChOgFFBG0SyCB8N4b')}</p>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          ),
        },
        button: {
          className: 'banner1-button m96u6oixptm-editor_css',
          children: (
            <span>
              <p>
                <br />
              </p>
            </span>
          ),
        },
      },
    ],
    autoPlay: true,
    type: ['across'],
    autoPlaySpeed: 5000,
  },
});
export const Content131DataSource = (t)=>({
  OverPack: {
    className: 'home-page-wrapper content13-wrapper m999dm48xhu-editor_css',
    playScale: 0.3,
  },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <div>
            <p>BMR8215-80</p>
            <h1>{t('ICBem1OU2ktkIrQ2bX7Wp')}</h1>
          </div>
        ),
        className: 'title-h1',
      },
      {
        name: 'image',
        children:
          'https://www.bmr-oe.com/static/images/bg/强激光127.png',
        className: 'title-image mexuctee5lk-editor_css',
      },
      {
        name: 'content2',
        children: (
          <span>
            <span>
              <span>
                <span>
                  <p>
                    {t('9ysG6Kks_OOGN8mpNpW5d')}
                  </p>
                  <p>
                    {t('ZKgdzLBz84WD2KlsGXjKs')}
                  </p>
                  <p>
                    {t('qa16tKz4Or_eilV888Js_')}
                  </p>
                  <p>
                    {t('PVZaE35rAt8gT5BGbFlNR')}
                  </p>
                  <p>
                    {t('IrEoqWtLb0MVknfhPmG4L')}
                  </p>
                </span>
              </span>
            </span>
          </span>
        ),
        className: 'title-content m99a2icryqg-editor_css',
      },
    ],
  },
});
export const Pricing20DataSource = (t)=>({
  wrapper: {
    className: 'home-page-wrapper pricing2-wrapper m99abc95oi-editor_css',
  },
  page: { className: 'home-page pricing2 m99aa4fupkr-editor_css' },
  OverPack: {
    playScale: 0.3,
    className: 'pricing2-content-wrapper m99a9po213-editor_css',
  },
  titleWrapper: {
    className: 'pricing2-title-wrapper m99bw5368cl-editor_css',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <p>{t('QTJpit5XfrGkWGvdh327E')}</p>
          </span>
        ),
        className: 'pricing2-title-h1 m99a49tp7i8-editor_css',
      },
    ],
  },
  Table: {
    name: 'tabsTitle',
    size: 'default',
    className:
      'pricing2-table m99a63ja4aq-editor_css m99a8j73b49-editor_css m99bf1xg1nh-editor_css',
    columns: {
      children: [
        {
          dataIndex: 'free',
          key: 'free',
          name: 'free',
          childWrapper: {
            className: 'pricing2-table-name-block',
            children: [
              {
                name: 'name',
                className: 'pricing2-table-name',
                children: (
                  <span>
                    <span>
                      <p>{t('MxjOHOQgk3msDOoxSWCnf')}</p>
                    </span>
                  </span>
                ),
              },
            ],
          },
        },
        {
          dataIndex: 'basic',
          key: 'basic',
          name: 'basic',
          childWrapper: {
            className: 'pricing2-table-name-block',
            children: [
              {
                name: 'name',
                className: 'pricing2-table-name',
                children: (
                  <span>
                    <span>
                      <p>{t('iCFFviGZieZuud9zXx5a-')}</p>
                    </span>
                  </span>
                ),
              },
            ],
          },
        },
        {
          dataIndex: 'pro',
          key: 'pro',
          name: 'pro',
          childWrapper: {
            className: 'pricing2-table-name-block',
            children: [
              {
                name: 'name',
                className: 'pricing2-table-name',
                children: (
                  <span>
                    <span>
                      <span>
                        <span>
                          <p>{t('F6GEw3ri2DjXxy08JvZ45')}</p>
                        </span>
                      </span>
                    </span>
                  </span>
                ),
              },
            ],
          },
        },
        {
          dataIndex: 'unlimited',
          key: 'unlimited',
          name: 'unlimited',
          childWrapper: {
            className: 'pricing2-table-name-block',
            children: [
              {
                name: 'name',
                className: 'pricing2-table-name',
                children: (
                  <span>
                    <span>
                      <p>{t('vgswPvgnQX_2Tqjuncy27')}</p>
                    </span>
                  </span>
                ),
              },
            ],
          },
        },
      ],
    },
    dataSource: {
      children: [
        {
          name: 'list0',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <p>1</p>
                      </span>
                    </span>
                  </span>
                </span>
              ),
              name: 'content0',
              className: 'pricing2-table-content m99bjttojeb-editor_css',
            },
            {
              children: (
                <span>
                  <p>{t('wXJxk-Qx-nk-B_iYp_-hA')}</p>
                </span>
              ),
              name: 'content1',
              className: 'pricing2-table-content m99bjqn06s-editor_css',
            },
            {
              children: (
                <span>
                  <p>{t('LDcp9HojK3t2I4WBAqSdp')}</p>
                </span>
              ),
              name: 'content2',
              className: 'pricing2-table-content m99bjmk6316-editor_css',
            },
            {
              children: (
                <span>
                  <span>
                    <p>Ф80×10mm</p>
                  </span>
                </span>
              ),
              name: 'content3',
              className: 'pricing2-table-content m99bjwmf1s8-editor_css',
            },
          ],
        },
        {
          name: 'list1',
          children: [
            {
              children: (
                <span>
                  <p>2</p>
                </span>
              ),
              name: 'content0',
              className: 'pricing2-table-content m99bkb1z7ws-editor_css',
            },
            {
              children: (
                <span>
                  <p>
                    <br />
                  </p>
                </span>
              ),
              name: 'content1',
              className: 'pricing2-table-content',
            },
            {
              children: (
                <span>
                  <p>{t('TwkkaW7gaWZyBY_kFfWBK')}</p>
                </span>
              ),
              name: 'content2',
              className: 'pricing2-table-content m99biypx1og-editor_css',
            },
            {
              children: (
                <span>
                  <p>{t('Rbh4ENmkLDcHqu14rx8mZ')}</p>
                </span>
              ),
              name: 'content3',
              className: 'pricing2-table-content m99afqi6x9a-editor_css',
            },
          ],
        },
        {
          name: 'list2',
          children: [
            {
              name: 'content0',
              children: (
                <span>
                  <p>3</p>
                </span>
              ),
              className: 'pricing2-table-content m99bkejdaur-editor_css',
            },
            {
              name: 'content1',
              children: (
                <span>
                  <p>
                    <br />
                  </p>
                </span>
              ),
              className: 'pricing2-table-content',
            },
            {
              name: 'content2',
              children: (
                <span>
                  <p>{t('TZs0kIewEdnHXNPPrGQJM')}</p>
                </span>
              ),
              className: 'pricing2-table-content m99bltgunb-editor_css',
            },
            {
              name: 'content3',
              children: (
                <span>
                  <p> ≥99.9%</p>
                </span>
              ),
              className: 'pricing2-table-content m99bjkp5yz-editor_css',
            },
          ],
        },
        {
          name: 'list3',
          children: [
            {
              children: (
                <span>
                  <p>4</p>
                </span>
              ),
              name: 'content0',
              className: 'pricing2-table-content m99bkhm8b3b-editor_css',
            },
            {
              name: 'content1',
              children: (
                <span>
                  <p>
                    {t('1yDWm4CrJFGIvOgpiDaVG')}<br />
                  </p>
                </span>
              ),
              className: 'pricing2-table-content m99bl6p9nf-editor_css',
            },
            {
              name: 'content2',
              children: (
                <span>
                  <p>{t('S8b-_p7CpsTVv2Zq-6KAO')}</p>
                </span>
              ),
              className: 'pricing2-table-content m99bm54unvo-editor_css',
            },
            {
              name: 'content3',
              children: (
                <span>
                  <p>{t('CWSZMJpSyDi0w-fckLeFO')}</p>
                </span>
              ),
              className: 'pricing2-table-content m99borf50f7-editor_css',
            },
          ],
        },
        {
          name: 'list4',
          children: [
            {
              name: 'content0',
              children: (
                <span>
                  <p>5</p>
                </span>
              ),
              className: 'pricing2-table-content m99bkkv0vl-editor_css',
            },
            {
              name: 'content1',
              children: (
                <span>
                  <span>
                    <span>
                      <p>
                        <br />
                      </p>
                    </span>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content',
            },
            {
              name: 'content2',
              children: (
                <span>
                  <p>{t('kaclxORCjMte0n-PYIsCJ')}</p>
                </span>
              ),
              className: 'pricing2-table-content m99bmakhv9g-editor_css',
            },
            {
              name: 'content3',
              children: (
                <span>
                  <span>
                    <p>≤1.3urad</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99botxcyi-editor_css',
            },
          ],
        },
        {
          name: 'list5',
          children: [
            {
              name: 'content0',
              children: (
                <span>
                  <p>6</p>
                </span>
              ),
              className: 'pricing2-table-content m99bknwfipn-editor_css',
            },
            {
              name: 'content1',
              children: (
                <span>
                  <span>
                    <p>
                      {t('TU37VyDTOwzo3GlYt6bAi')}<br />
                    </p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bnta347-editor_css',
            },
            {
              name: 'content2',
              children: (
                <span>
                  <p>{t('SQ6KjcppbgioVWuJEyJ93')}</p>
                </span>
              ),
              className: 'pricing2-table-content m99bmcmbc3p-editor_css',
            },
            {
              name: 'content3',
              children: (
                <span>
                  <span>
                    <p> ±2.0︒</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bmhzwzwu-editor_css',
            },
          ],
        },
        {
          name: 'list~m9992qcqan',
          children: [
            {
              name: 'content0',
              children: (
                <span>
                  <span>
                    <p>7</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bkqpz8xs-editor_css',
            },
            {
              name: 'content1',
              children: (
                <span>
                  <span>
                    <span>
                      <p>
                        <br />
                      </p>
                    </span>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content',
            },
            {
              name: 'content2',
              children: (
                <span>
                  <span>
                    <p>{t('qyiikA3lu1lo6ncG67H6N')}</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bmflz1ur-editor_css',
            },
            {
              name: 'content3',
              children: (
                <span>
                  <span>
                    <span>
                      <p> ≥400Hz</p>
                    </span>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bp1b7c4n-editor_css',
            },
          ],
        },
        {
          name: 'list~m9995d9gi2j',
          children: [
            {
              name: 'content0',
              children: (
                <span>
                  <span>
                    <p>8</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bkw8os8b-editor_css',
            },
            {
              name: 'content1',
              children: (
                <span>
                  <span>
                    <span>
                      <p>
                        <br />
                      </p>
                    </span>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content',
            },
            {
              name: 'content2',
              children: (
                <span>
                  <span>
                    <p>{t('c6_lwfijlZ_RZqM-zoULP')}</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bmikkli-editor_css',
            },
            {
              name: 'content3',
              children: (
                <span>
                  <span>
                    <p> ≤2.5ms</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bpp70n5f-editor_css',
            },
          ],
        },
        {
          name: 'list~m9995e20r0n',
          children: [
            {
              name: 'content0',
              children: (
                <span>
                  <span>
                    <p>9</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bkwrio7-editor_css',
            },
            {
              name: 'content1',
              children: (
                <span>
                  <span>
                    <span>
                      <p>
                        {t('8Z05ar2sRQN25DVVk0glz')}<br />
                      </p>
                    </span>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bl7ryoos-editor_css',
            },
            {
              name: 'content2',
              children: (
                <span>
                  <span>
                    <p>{t('ARwosmH872LJr3cvXpsY5')}</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bl9cj9-editor_css',
            },
            {
              name: 'content3',
              children: (
                <span>
                  <span>
                    <p> {t('TE4I3X33AaH60yJAyGMa0')}</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bsnq4szi-editor_css',
            },
          ],
        },
        {
          name: 'list~m9995ewkw1m',
          children: [
            {
              name: 'content0',
              children: (
                <span>
                  <span>
                    <p>10</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bkyuktdf-editor_css',
            },
            {
              name: 'content1',
              children: (
                <span>
                  <span>
                    <span>
                      <p>
                        <br />
                      </p>
                    </span>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content',
            },
            {
              name: 'content2',
              children: (
                <span>
                  <span>
                    <span>
                      <p> {t('z9qGgEYx_JBlULmhvm5XP')}</p>
                    </span>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bmokz5m7-editor_css',
            },
            {
              name: 'content3',
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <p> ≤3A</p>
                      </span>
                    </span>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bq7klifu-editor_css',
            },
          ],
        },
      ],
    },
  },
});
export const Content130DataSource = (t)=>({
  OverPack: {
    className: 'home-page-wrapper content13-wrapper m994rqea0y-editor_css',
    playScale: 0.3,
  },
  titleWrapper: {
    className: 'title-wrapper m99d35o3ufq-editor_css',
    children: [
      {
        name: 'image',
        children:
          'https://www.bmr-oe.com/static/images/size/强激光127.png',
        className: 'title-image m99d1c63x6g-editor_css',
      },
      {
        name: 'title',
        children: (
          <span>
            <span>
              <p>{t('7IOs688hmRZyvhSsP1VYf')}</p>
            </span>
          </span>
        ),
        className: 'title-h1 m994tqtqy6-editor_css',
      },
      {
        name: 'content',
        children: (
          <span>
            <span>
              <span>
                <p>{t('LP6SiJ2GMSFebLSkTX0h7')}</p>
              </span>
            </span>
          </span>
        ),
        className: 'title-content m99cy2eu9e9-editor_css',
      },
    ],
  },
});
export const Content132DataSource = (t)=>({
  OverPack: {
    className: 'home-page-wrapper content13-wrapper m99ctseby8q-editor_css',
    playScale: 0.3,
  },
  titleWrapper: {
    className: 'title-wrapper m99d7t921cf-editor_css',
    children: [
      {
        name: 'image',
        children:
          'https://www.bmr-oe.com/static/images/size/数字电涡流驱动板.png',
        className: 'title-image mf28jwxlki6-editor_css',
      },
      {
        name: 'title',
        children: (
          <span>
            <p>{t('YHKLebO0aPcqLbinByGMV')}</p>
          </span>
        ),
        className: 'title-h1 mfd2xcbf3an-editor_css',
      },
      {
        name: 'content',
        children: (
          <span>
            <p>{t('VPS3onGOejT4_J64nL8mt')}</p>
          </span>
        ),
        className: 'title-content m99czfafr5e-editor_css',
      },
    ],
  },
});
export const Footer10DataSource = (t)=>({
  wrapper: { className: 'home-page-wrapper footer1-wrapper' },
  OverPack: { className: 'footer1', playScale: 0.2 },
  block: {
    className: 'home-page',
    gutter: 0,
    children: [
      {
        name: 'block0',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          className: 'logo',
          children:
            'https://www.bmr-oe.com/static/images/logo15.png',
        },
        childWrapper: {
          className: 'slogan',
          children: [
            {
              name: 'content0',
              children: (
                <span>
                  <p>{t('3YJQxEFqCUHaZrBqiBUcJ')}</p>
                </span>
              ),
              className: 'm8frbj7scy-editor_css',
            },
          ],
        },
      },
      {
        name: 'block1',
        xs: 24,
        md: 6,
        className: 'block',
        title: { 
          children: (
            <span >
              <p>{t('aQ11KBCPI-NqvljWeA8Z5')}</p>
            </span>
            ),
        },
        childWrapper: {
          children: [
            {
              name: 'link0',
              href: '/产品手册-V1.1.pdf',
              children: (
                <span>
                  <span>
                    <p>{t('1e97m24DeFQlF47oLnzT6')}</p>
                  </span>
                </span>
              ),
            },
            {
              name: 'link2',
              href: '/接口定义-V1.0.pdf',
              children: (
                <span>
                  <span>
                    <span>
                      <p>{t('buQ5ZwFW6-FfbT4fcdCYm')}</p>
                    </span>
                  </span>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block2',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          children: (
            <span>
              <p>{t('nJav6eBS22Rk_k7lBarZJ')}</p>
            </span>
          ),
        },
        childWrapper: {
          children: [
            {
              href: '/#/eighth',
              name: 'link0',
              children: (
                <span>
                  <span>
                    <p>{t('q7mNyEuANkBc8dzF-sp6r')}</p>
                  </span>
                </span>
              ),
            },
            {
              href: '/#/ninth',
              name: 'link1',
              children: (
                <span>
                  <p>{t('Dv0WIDdoVpbNzutM_OhS2')}</p>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block3',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          children: (
            <span>
              <p>{t('WNaqYjrFHo96HLeZlg9ic')}</p>
            </span>
          ),
        },
        childWrapper: {
          children: [
            {
              href: '/#/seventh',
              name: 'link0',
              children: (
                <span>
                  <span>
                    <span>
                      <p>{t('KSB5A665NvbxkjPW18Owd')}</p>
                    </span>
                  </span>
                </span>
              ),
            },
            {
              href: '/#/sixth',
              name: 'link1',
              children: (
                <span>
                  <span>
                    <span>
                      <p>{t('VoWWitdYdemyOG0UiTAYJ')}</p>
                    </span>
                  </span>
                </span>
              ),
            },
          ],
        },
      },
    ],
  },
  copyrightWrapper: { className: 'copyright-wrapper' },
  copyrightPage: { className: 'home-page' },
  copyright: {
    className: 'copyright',
    children: (
      <span>
        <span>{t('PjEdy6oHyogb0WDcl0Lg_')}</span>
      </span>
    ),
  },
});
